import React, { memo, useCallback } from "react";

import {
  Button,
  Center,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";

import colors from "app/colors";
import { PhoneSmsIcon } from "modules/icons";
import useUserPreference from "modules/hooks/use-user-preference";
import { useAuth } from "modules/providers/auth-provider";
import { useOverlay } from "modules/providers/overlay-provider";

const DisableSmsModal = () => {
  const { me } = useAuth();
  const { closeModal } = useOverlay();
  const { upsertUserPreference } = useUserPreference({
    userId: me?.id,
    name: "SMS",
  });

  const onTurnOffClicked = useCallback(() => {
    upsertUserPreference(false);
    closeModal();
  }, [closeModal, upsertUserPreference]);

  return (
    <Modal isOpen onClose={closeModal} isCentered size="sm">
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody p={6}>
          <VStack spacing={4}>
            <PhoneSmsIcon boxSize={16} fill={colors.blackSecondary} />
            <Text fontSize={20} fontWeight={600} fontFamily="Outfit">
              Get Texts for Synco Messages?
            </Text>
            <Text textAlign="center" fontWeight={400} fontSize={14}>
              You are set up to receive text messages on your mobile device for
              every Synco message you receive.
              <br />
              (Modify this setting anytime in "My Profile")
            </Text>
            <Center>
              <HStack w="full" spacing={6}>
                <Button
                  variant="cancel"
                  height={50}
                  w={139}
                  onClick={closeModal}
                  fontWeight={700}
                  fontSize={16}
                >
                  Keep Active
                </Button>
                <Button
                  height={50}
                  w={139}
                  onClick={onTurnOffClicked}
                  fontWeight={700}
                  fontSize={16}
                >
                  Turn Off
                </Button>
              </HStack>
            </Center>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(DisableSmsModal);
